import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { copyToClipboard } from '../../utils/clipboard-util';

/**
 * Presents arbitrary text to the user, and lets them copy it to their clipboard with a click.
 *
 * Only the plaintext equivalent of the content is copied. This means you can include formatting.
 *
 * @example
 * <app-copy-text>example text</app-copy-text>
 * // copies "example text"
 */
@Component({
  selector: 'app-copy-text',
  templateUrl: './copy-text.component.html',
  styleUrls: ['./copy-text.component.scss'],
  standalone: false
})
export class CopyTextComponent {
  @ViewChild('copyContent') public copyContent: ElementRef<HTMLSpanElement>;

  /** An optional override of the text to copy. */
  @Input() public copy: string | null = null;

  public copyText(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();

    const text = this.copy ?? this.copyContent.nativeElement.textContent;
    if (text) {
      copyToClipboard(text);
      window.getSelection()?.removeAllRanges();
    }
  }
}
